import MonthlySubmissionConfirmationPage from './MonthlySubmissionConfirmationPage';

export default MonthlySubmissionConfirmationPage;